import React from "react";
import { useQuery } from "@apollo/client";

import photoPricesQuery from "queries/photoPrices";
import Loader from "../loader";
import styles from "./style.module.scss";

const Price = ({ pricesRef }) => {
  const { loading, data } = useQuery(photoPricesQuery);

  if (loading) {
    return (
      <div id="prices" ref={pricesRef} className={styles.price__wrapper}>
        <h2 className={styles.price__heading}>РАСЦЕНКИ</h2>
        <div className={styles.main__container}>
          <Loader />
        </div>
      </div>
    );
  }

  const priceItems = data?.photoPricesCollection?.items || [];

  const staticDetails = [
    { cost: "280 р.", text: "Покраска штампованных дисков" },
    { cost: "400 р.", text: "Покраска литых дисков" },
    { cost: "780 р.", text: "Покраска литых дисков с алмазной проточкой" }
  ];

  const sortedPrices = [...priceItems].sort((a, b) => a.number - b.number);
  
  return (
    <div id="prices" ref={pricesRef} className={styles.price__wrapper}>
      <h2 className={styles.price__heading}>РАСЦЕНКИ</h2>
      <div className={styles.main__container}>
        {sortedPrices.map((item, index) => {
          if (!item.photo?.url) return null;

          const details = staticDetails[index] || { cost: "—", text: item.photo.description || "" };

          return (
            <div key={index} className={styles.price__card}>
              <p className={styles.price__cost}>
                от {details.cost}
                <br />
                <span>за комплект</span>
              </p>

              <img
                className={styles.price__image}
                src={item.photo.url}
                alt={item.photo.description || "price card"}
              />

              <p className={styles.heads__first}>
                <center>{details.text}</center>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Price;